const state = () => ({
    messageObj: Object,
    userId: null,
    calendarTimeEdit: false,
    timezoneCurrentUser: null,
    timezoneCurrentUserId: null,
    accessUserId: [1,3,32175, 99143, 57891, 214] //tmp
});

const actions = {};

const getters = {
    getMessageId: (state) => state.messageObj.id,
    getMessageUserId: (state) => {
        if (state.messageObj.schedule_meeting_time) {
            return state.messageObj.user_id;
        } else if (state.messageObj.schedule_meeting_time_message) {
            return state.messageObj.schedule_meeting_time_message.schedule_meeting_time.conversationMessageAttrib.user.id
        }

    },
    getUserId: (state) => state.userId,
    getMeetingTime: (state) => {
        if (state.messageObj.schedule_meeting_time) {
            return state.messageObj.schedule_meeting_time
        } else if (state.messageObj.schedule_meeting_time_message) {
            return state.messageObj.schedule_meeting_time_message.schedule_meeting_time
        }
    },
    getMessageObj: (state) => state.messageObj,
    getCalendarTimeEdit: (state) => state.calendarTimeEdit,
    getTimezoneCurrentUser: (state) => state.timezoneCurrentUser,
    getTimezoneCurrentUserId: (state) => state.timezoneCurrentUserId,
    getAccessUserId: (state) => state.accessUserId, //tmp
};

const mutations = {
    setMessageObj(state, messageObj) {
        state.messageObj = messageObj;
    },
    setCurrentUserId (state, userId) {
        state.userId = userId;
    },
    setCalendarTimeEdit (state, val) {
        state.calendarTimeEdit = val;
    },
    setTimezoneCurrentUser (state, val) {
        state.timezoneCurrentUser = val;
    },
    setTimezoneCurrentUserId (state, val) {
        state.timezoneCurrentUserId = val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
